import React, { createContext, useMemo } from 'react';

import useGetUserDetails from 'hooks/useGetUserDetails';

export interface User {
  firstName: string;
  lastName: string;
  initials: string;
  email: string;
  photoUrl?: string;
  companyRank: string;
  company: {
    id: string;
    name: string;
    created_at: string;
    company_type: string;
  };
}

export interface IUserContext {
  userProfile: User;
}

export const UserContext = createContext<IUserContext>({
  userProfile: {
    firstName: '',
    lastName: '',
    initials: '',
    email: '',
    companyRank: '',
    company: {
      id: '',
      name: '',
      created_at: '',
      company_type: '',
    },
  },
});

interface UserProviderProps {
  children: React.ReactNode;
}

const UserProvider = ({ children }: UserProviderProps) => {
  const { data: userProfileData } = useGetUserDetails();

  const value = useMemo(
    () => ({
      userProfile: {
        firstName: userProfileData?.first_name ?? '',
        lastName: userProfileData?.last_name ?? '',
        initials: userProfileData?.initials ?? '',
        email: userProfileData?.email ?? '',
        photoUrl: userProfileData?.photo_url,
        companyRank: userProfileData?.company_rank ?? '',
        company: {
          id: userProfileData?.company?.id ?? '',
          name: userProfileData?.company?.name ?? '',
          created_at: userProfileData?.company?.created_at ?? '',
          company_type: userProfileData?.company?.company_type ?? '',
        },
      },
    }),
    [userProfileData]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserProvider;
